import { ModelDef } from '../../../common/$models/ModelDef'
import { ModelRecordWorkflowThreadItems } from './RecordWorkflowThreadItems'

const model: ModelDef = {
  tableName: 'record_workflow_threads',
  tableLabel: 'ワークフロースレッド',
  primaryKeyColType: 'UUID',
  columns: {
    id: {
      type: 'UUID',
      label: 'ID',
    },
    definitionId: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: 'ワークフロー定義',
      validate: { notEmpty: true },
      relationshipManyToOne: {
        collectionName: 'record_workflow_definitions',
        labelFormatter: (record) => record.name,
      },
    },
    targetModelName: {
      type: 'STRING',
      label: '対象モデル名',
      validate: { notEmpty: true },
    },
    recordId: {
      type: 'STRING',
      label: '対象レコードID',
      validate: { notEmpty: true },
    },
    status: {
      type: 'SELECT',
      label: 'ステータス',
      validate: { notEmpty: true },
      selections: () => [
        { value: 'active', label: '進行中' },
        { value: 'completed', label: '完了' },
        { value: 'cancelled', label: 'キャンセル' },
      ],
      defaultValue: 'active',
    },
    startedAt: {
      type: 'DATETIME',
      label: '開始日時',
      validate: { notEmpty: true },
      defaultValue: () => new Date().toISOString(),
    },
    startedBy: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: '開始ユーザー',
      validate: { notEmpty: true },
      relationshipManyToOne: {
        collectionName: 'directus_users',
        labelFormatter: (record) => `${record.first_name} (${record.email})`,
      },
    },
    completedAt: {
      type: 'DATETIME',
      label: '完了日時',
    },
    metadata: {
      type: 'JSON',
      label: 'メタデータ',
    },
    items: {
      type: 'RELATIONSHIP_ONE_TO_MANY',
      label: 'アイテム',
      relationshipOneToMany: {
        collectionName: 'record_workflow_thread_items',
        fieldName: 'threadId',
        sortFieldName: 'routeIndex',
      },
      width: {
        xs: 48,
      },
    },
  },
}

export const record_workflow_threads = model

export type ModelRecordWorkflowThreads = {
  id: string
  definitionId: string
  targetModelName: string
  recordId: string
  status: 'active' | 'completed' | 'cancelled'
  startedAt: string
  startedBy: string
  completedAt: string
  metadata: Record<string, unknown>
  items: ModelRecordWorkflowThreadItems[]
}
